import { memo, useCallback } from "react";
import { useLogout } from "src/auth/useAuth";
import { Button } from "src/components/ui/button";
import { HeaderText, LightText } from "src/components/v1";
import config from "src/config";

/**
 * Shown when a logged-in user has no resolvable dashboard (no broker/applicant/
 * borrower/etc. account type). Previously this state fell through to an infinite
 * loading spinner in BrokerOrBorrowerRoutes; this gives the user a clear message
 * and a way out instead.
 */
const NoAccountView = () => {
  const { logout } = useLogout();

  const onLogout = useCallback(() => {
    void logout();
  }, [logout]);

  return (
    <div className="h-screen w-full flex flex-col justify-center items-center px-6 bg-background">
      <HeaderText className="font-bold mt-4 text-center">No roles associated with this account</HeaderText>
      <LightText className="text-lg m-8 max-w-[624px] text-center">
        Your account isn't connected to any {config.brandName} roles yet, so there's nothing to show here. If
        you think this is a mistake, reach out to{" "}
        <a className="text-green underline" href={`mailto:${config.brandSupportEmail}`}>
          {config.brandSupportEmail}
        </a>
        .
      </LightText>
      <div className="flex gap-3">
        <a href={`mailto:${config.brandSupportEmail}`} className="no-underline">
          <Button variant="outline">Contact support</Button>
        </a>
        <Button variant="green" onClick={onLogout}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default memo(NoAccountView);
